/**
 * Hard-reload the add-in task pane.
 *
 * Used only by ConnectionErrorNotice's Retry: when the settings endpoint is
 * unreachable, a full reload re-runs sign-in and re-establishes the connection
 * from scratch. The access-block notices (revoked/changed/channel) instead do a
 * soft re-validate via appConfig.refresh, so they don't reload. Wrapped in a
 * helper so tests can mock it and so the `window` guard lives in one place.
 */
export function reloadAddin(): void {
  if (typeof window !== "undefined") {
    window.location.reload();
  }
}
